import { useRef } from "react"
import { useScheduleWithStatus } from "routes/schedule/lib/useSchedule"
import Schedules from "routes/schedule/schedules"
import { ScheduleDetails } from "routes/schedule/schedule-details"
import { LoadingTemplate } from "lib/@components/loading-template"
import { TranslationStateProvider } from "routes/schedule/plugins/translation/translation-state-provider"
import { TranslationDirBox } from "routes/schedule/plugins/translation/translation-dir-box"

const EMPTY_TRANSLATION_STATE = {
    loading: false,
    isTranslated: false,
    language: "en",
    rtl: false,
    error: null,
    translationMeta: null,
    labels: null,
    translatedSkills: null,
}

export function ScheduleById({ id }) {
    const { schedule: rawSchedule, ...props } = useScheduleWithStatus(id)
    const translationState = useRef(EMPTY_TRANSLATION_STATE)

    return (
        <Schedules>
            <LoadingTemplate
                {...props}
                errorHeader="Can't display this schedule"
                schedulePath={id}
                schedule={rawSchedule}
                target={rawSchedule}
                translationState={translationState}
            >
                <TranslationStateProvider>
                    <TranslationDirBox
                        sx={{
                            display: "flex",
                            flex: 1,
                            flexDirection: "column",
                            minHeight: 0,
                            overflow: "hidden",
                        }}
                    >
                        <ScheduleDetails />
                    </TranslationDirBox>
                </TranslationStateProvider>
            </LoadingTemplate>
        </Schedules>
    )
}
